var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRodtkort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5165,
    cy: 14.0766,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5155 20.5724L13.7396 18.9383C13.8361 18.8094 13.8024 18.621 13.6643 18.5175L10.1627 15.8946C10.0246 15.7912 9.83431 15.8118 9.73774 15.9407L8.51373 17.5748",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6489 16.2589C11.6108 10.2835 10.0195 11.9158 16.8873 8.481",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0847 16.6863L17.1637 17.4946C17.2963 17.5939 17.4604 17.6401 17.6198 17.6228C17.7792 17.6055 17.9209 17.5262 18.0136 17.4024L22.2102 11.7998C22.4034 11.542 22.336 11.1652 22.0597 10.9583L18.0579 7.96069C17.7816 7.75375 17.4011 7.79503 17.2079 8.05288L13.0113 13.6554C12.8743 13.8384 12.7969 14.1617 13.0949 14.2027L15.7844 12.6576C16.5905 12.1777 17.3745 13.5164 16.568 13.9967C16.0827 14.2921 15.6368 14.6427 15.2386 15.0417C15.0453 15.9077 14.6608 16.7103 14.1111 17.3945L13.4117 18.3283",
    fill: "#D52B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0847 16.6863L17.1637 17.4946C17.2963 17.5939 17.4604 17.6401 17.6198 17.6228C17.7792 17.6055 17.9209 17.5262 18.0136 17.4024L22.2102 11.7998C22.4034 11.542 22.336 11.1652 22.0597 10.9583L18.0579 7.96069C17.7816 7.75375 17.4011 7.79503 17.2079 8.05288L13.0113 13.6554C12.8743 13.8384 12.7969 14.1617 13.0949 14.2027L15.7844 12.6576C16.5905 12.1777 17.3745 13.5164 16.568 13.9967C16.0827 14.2921 15.6368 14.6427 15.2386 15.0417C15.0453 15.9077 14.6608 16.7103 14.1111 17.3945L13.4117 18.3283",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodtkort);
export default __webpack_public_path__ + "static/media/rodtkort.a714548aff6e55da53415ba64d987e92.svg";
export { ForwardRef as ReactComponent };